export default "__VITE_ASSET__Bnb3HZWo__"